import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel, FormControl, Select as MaterialSelect  ,Box ,TextField,
  FormControlLabel, LinearProgress, Checkbox, Typography,
RadioGroup, Radio, FormLabel} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import Modal from '../Generales/ModalTam';
import Rating from '@material-ui/lab/Rating';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const NvoEditDomicilio = ({modalAbierto,setModalAbierto,titulo,regis,funcionActuliza, Proveedor}) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [registro, setRegistro]= useState({Orden:0, Direccion:"", Alias:"", Descr:"", Municipio:"",Estado:"",Responsable:"",
          Email:"", Contacto:""});  
  const {Orden,  Direccion, Alias, Descr, Municipio, Estado,Responsable, Email, Contacto  }=registro    
  
  const [listEstado, setListEstado] = useState([])  
  const [listMuni, setListMuni] = useState([])    
  
  React.useEffect(()=>{     
    
    if (regis.length !== 0) {
      setRegistro({...registro,  Estado:regis.EdoId, Municipio:regis.MunId, 
        Direccion:regis.Dir, Alias:regis.Alias, Orden:regis.Id, Descr:regis.Descr, Responsable: regis.Responsable,
        Contacto:regis.Contacto, Email:regis.Email })       
      getListMuni(regis.EdoId)
    }
         
    getListEstado()
          

    return ()=> {
      source.cancel();
    }     
      // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

const getListEstado = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/ubicacion/estado";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListEstado(aux);                                      
      }         
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  };  

  const getListMuni = (EdoId) => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      Estado:EdoId,
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/ubicacion/estado/municipio";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListMuni(aux);                                      
      }         
    }
    llamadaApiToken(data, url,respuesta,ErrorGeneral,history,source);
  };    

  const registrarNActividad=()=>{               
  
    //let NomUsu= localStorage.getItem('UsuarioNom');  
    const data = qs.stringify({
      Llave:Orden,
      Usuario:idusu,                  
      Estado:Estado,
      Municipio:Municipio,
      Alias: Alias,
      Status:1,            
      Proveedor:Proveedor.Id,
      Responsable:Responsable,
      Domicilio:Direccion,
      Email:Email,
      Contacto:Contacto,
      ip:"172.2.0.0",      
      idDispositivo:'8978yuhjnfrsdsd'
    });
    const url = "/renta/proveedor/domicilio/new-edit";
  
    function respuesta(aux) {
      if (aux.respuesta==1) 
      { //console.log(aux);
        let mensaje= regis.length!==0 ?
        `Se edito correctamente el registro "${Descr} " `        
        :`Se Registro correctamente el nuevo Domicilio `
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)     
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });       
        funcionActuliza()
        setModalAbierto(false)            
      }   
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);     
  }

  const onChange = e =>
  { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if ((expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value) )||e.target.value===' '||e.target.value==='') 
    {
    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };
  
  const guardTerminal = e =>
  {
    setRegistro({ ...registro, [e.target.name] : e.target.value })
  };

  const onChangeEdo = e =>
  {
    if (e.target.value!==0 && e.target.value!=="0" && e.target.value!=="") {
      getListMuni(e.target.value)  
    }    
    setRegistro({ ...registro, [e.target.name] : e.target.value, Municipio:"" })
  };

  const onChangeNumTel = e =>
	{ let expNopermitida= new RegExp('[A-Za-z$@#_&-()/:;!?,<>=]');          
    let expComilla = new RegExp("'");
    let expMas = new RegExp('-');     
    let expMenos = new RegExp('\\+');     
    let expCadena = new RegExp('[0-9]');             
    if (  e.target.value.length<=10 &&( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
      && !expMenos.test(e.target.value) && !expMas.test(e.target.value) && !expComilla.test(e.target.value) ) 
      || e.target.value===' '|| e.target.value==='') 
    {
      setRegistro({ ...registro,[e.target.name] : e.target.value })            
       
    }		    

	}; 

  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    if (valor!= null && valor!= '' && valor!= '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    { mostrarAlertas(mensaje)  
    }
    return respuesta
  }

  
  const mostrarAlertas =(auxMensaje)=>{ 
    setTipoAdvertencia("warning")
    let mensaje=auxMensaje            
    setMensaje(mensaje);
    setAviso(true)   
  } 

  function valNulos(auxMensaje,auxCampo) 
  {    let valida=false    
    if ( auxCampo !== '' && auxCampo !== '0' && auxCampo !==0 
        && auxCampo !== null && auxCampo!==" " ) 
    {   valida=true              
    }
    if (!valida) 
    {   mostrarAlertas(auxMensaje)
    }
    return valida
  }
  const verificaNulos = (descripcion, campo)=>{
    let respuesta =false;        
        
    if(campo===null|| (typeof campo !== 'number' && typeof campo === 'string' 
      && (campo.trim() === '' || campo.trim() === null) )
    ) 
    {   respuesta=true;                      
    }
      if (!respuesta) 
    {   mostrarAlertas(descripcion)
    }
    return(respuesta);
  }
  
  const verificaTel = (auxCampo,auxMensaje,auxTamanio)=>{
    let respuesta =false;        
      
    if(validaVariable(auxCampo,auxMensaje,auxTamanio)    ) 
    {   
      if (typeof auxCampo === 'number' ) {
        respuesta =true
      }
    }
    if (!respuesta) 
    {   mostrarAlertas(auxMensaje)
    }
    console.log(typeof auxCampo,respuesta);
    
    return(respuesta);
  }

  function validaVariable(auxCampo,auxMensaje,auxTamanio) 
  { let respuesta=false
    if ( verificaNulos(auxMensaje,auxCampo) ) 
    { if (auxCampo.length>=auxTamanio ) 
      {                
        respuesta=true                    
      }else
      {            
        mostrarAlertas(`${auxMensaje}`) 
      }
    }        
    return respuesta;
  }

  const guardarDatos = () => 
  {
    if (verificaTel(Contacto, "Llenar campo de Teléfono (10 caracteres)",10) &&
      validaDatos(Estado,"Seleccionar Estado") && validaDatos(Municipio,"Seleccionar Municipio") &&
      validaVariable(Responsable, "Llenar campo de Responsable (mayor o igual 5 caracteres)",5) &&
      validaVariable(Alias, "Llenar campo de Alias (mayor o igual 5 caracteres)",5) &&
      validaVariable(Direccion, "Llenar campo de Dirección (mayor o igual 5 caracteres)",5) &&
      
      validaVariable(Email, "Llenar campo de Email (mayor o igual 5 caracteres)",5) 
    ) 
    {
      
      registrarNActividad()                                                                                               
    }                            
  };

  const onChangeRef = e =>
  { let expNopermitida = new RegExp('[$!?]');
    //let expMenos = new RegExp('-');
    //let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9#_:%-({})/*=|]');
    if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) ) 
        || e.target.value===' ' || e.target.value==='') 
    {    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };


  
  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} 
    setEspera={setEspera}  tamanio={"md"} btnDesact={btnDesact}
  >
  <form className={classes.root} noValidate autoComplete="off" fullWidth style={{width:30+'rem'}} >    
    <Box display={"flex"} flexDirection={"column"}>
    <Box display={"flex"} flexDirection={"row"}  >
    {listEstado.length!==0 ?  
      <Box display="flex" flexDirection="row" mr={2}>        
        <FormControl className={classes.formControl} size="small" style={{width:12+'rem'}}>
          <InputLabel htmlFor="age-native-simple">Estado</InputLabel>
          <MaterialSelect
            native value={Estado}  onChange={onChangeEdo}
            inputProps={{ name: 'Estado', id: 'Estado', }}            
          >
            <option aria-label="None" value="" />      
            {listEstado.map((row) => (
                <option value={row.Id}>{row.Nom}</option>
            ))}   
          </MaterialSelect>
        </FormControl>             
      </Box> 
      :<LinearProgress color="primary" />}    
      {listMuni.length!==0 ?  
       <Box display="flex" flexDirection="row">        
        <FormControl className={classes.formControl} size="small" style={{width:14+'rem'}}>
          <InputLabel htmlFor="age-native-simple">Municipio</InputLabel>
          <MaterialSelect
            native value={Municipio}  onChange={guardTerminal}
            inputProps={{ name: 'Municipio', id: 'Municipio', }}            
          >
            <option aria-label="None" value="" />      
            {listMuni.map((row) => (
                <option value={row.Id}>{row.Nom}</option>
            ))}   
          </MaterialSelect>
        </FormControl>             
      </Box> 
      :null}   
    </Box>

      <Box style={{width:30+'rem'}} mt={2}>      
      <FormControl component="fieldset" style={{width:28+'rem'}}>    
        <TextField id="outlinedDescr" variant='outlined'           
          label="Responsable"  size="small"
          value={Responsable} onChange={onChangeRef}  
          name="Responsable" fullWidth
        /> 
      </FormControl>
      </Box>     
      <Box style={{width:30+'rem'}} mt={2}>      
      <FormControl component="fieldset" style={{width:28+'rem'}}>    
        <TextField id="outlinedAlias" variant='outlined'           
          label="Alias"  size="small"
          value={Alias} onChange={onChangeRef}  
          name="Alias" fullWidth
        /> 
      </FormControl>
      </Box>     
      
      <Box style={{width:30+'rem'}} mt={2}>      
      <FormControl component="fieldset" style={{width:28+'rem'}}>    
        <TextField id="outlinedDescr" variant='outlined'           
          label="Dirección"  size="small"
          value={Direccion} onChange={onChangeRef}  
          name="Direccion" fullWidth
        /> 
      </FormControl>
      </Box>   
      <Box display="flex" style={{width:30+'rem'}}>
        <Box style={{width:9+'rem'}} mt={2} mr={1}>      
          <FormControl component="fieldset" style={{width:9+'rem'}}>    
            <TextField  id="CInt-input" onChange={onChangeNumTel} style={{width:9+'rem'}}
              label="Teléfono" defaultValue="Contacto" value={Contacto} name='Contacto' size="small" type="number"
              inputProps= {{ maxlength: 10 }} autoComplete='off' variant='outlined'           
            /> 
            
          </FormControl>
        </Box>       
        <Box  mt={2}>      
        <FormControl component="fieldset" style={{width:'18.5rem'}}>    
          <TextField id="outlinedEmail" variant='outlined'           
            label="Email"  size="small"
            value={Email} onChange={onChangeRef}  
            name="Email" fullWidth
          /> 
        </FormControl>
        </Box>     
      </Box>
      </Box>                           
      </form>
  </Modal>
  );
}
 
export default NvoEditDomicilio;